import { Component } from 'react';
import ColumnSelectComponent from './ColumnSelectComponent';

class ChooseProductFirstHead extends Component {
  render() {
    return (
      <thead>
        <tr>
          <th className="no-background" colSpan={3} />
          <ColumnSelectComponent
            classNames={'choose-product__select-frt'}
          />
          <th className="no-background" colSpan={1} />
          <th className="no-background" colSpan={1} />
        </tr>
      </thead>
    );
  }
}

export default ChooseProductFirstHead;
